import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { CoachBillingPage } from 'pages/coach-billing/coach-billing-page';

@NgModule({
  declarations: [CoachBillingPage],
  imports: [PagesModule, ComponentsModule],
  exports: [CoachBillingPage],
})
export class CoachBillingPageModule {}
